import { TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const PYLON_IDENTITY_HASH_GET = "pylon-identity-hash-get";

interface PylonIdentityHashResponse {
  hash: string | null;
}

export const getPylonIdentityHash = async () => {
  try {
    const response = await http.get<PylonIdentityHashResponse>(
      links.pylon.identityHash,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
